// extracted by mini-css-extract-plugin
export default {"youIMyContentContainer":"yOm-+nsnRLlYlYCuuatwCw==","youICard":"M9ePx+tDlWy8GfcrVNjFJw==","cardMinHeight":"ZhLEdiBYCudWd9kbDNJlQg==","cardTitle":"t0M1XsmDSkP1RKmi+Sy26A=="};